module.exports = __webpack_public_path__ + "static/media/icone-detetive-da-multa.14871f05.png";